import * as React from 'react';
import {Client as Styletron} from 'styletron-engine-atomic';
import {Provider as StyletronProvider} from 'styletron-react';

const engine = new Styletron();

export const Provider = ({children}: {children: React.ReactNode}) => (
  <StyletronProvider value={engine}>{children}</StyletronProvider>
);
